import $api from "../http";
import { ILastMinuteDeal, ILastMinuteDealCreateModel } from "../models/LastMinuteDeal";

class LastMinuteDealServiceClass {
  async getAll(currentPage: number | undefined, pageSize: number | undefined) {
    let queryString = `currentPage=${currentPage}&pageSize=${pageSize}`;
    return $api.get<{ items: ILastMinuteDeal[]; total: number }>(
      `api/last-minute-deal?${queryString}`
    );
  }

  async getById(id: string) {
    return $api.get<ILastMinuteDeal>(`api/last-minute-deal/${id}`);
  }

  async create(model: ILastMinuteDealCreateModel) {
    return await $api.post<{}>("api/last-minute-deal", model);
  }

  async update(id: string, model: ILastMinuteDealCreateModel) {
    return await $api.put<{}>(`api/last-minute-deal/${id}`, model);
  }

  async delete(id: string) {
    return await $api.delete<{}>(`api/last-minute-deal/${id}`);
  }
}

export const LastMinuteDealService = new LastMinuteDealServiceClass();
